import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import {AuthService} from '../securite/service/auth.service';
import {StructureService} from '../structure/services/structure.service';
import {ParametreService} from '../parametre/parametre.service';
import {CandidatureService} from '../candidature/services/candidature.service';
import {CandidatService} from '../candidat/services/candidat.service';
import {Candidature} from '../candidature/models/candidature.model';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService,
              private router: Router,
              private strutureService: StructureService,
              private parametreService: ParametreService,
              private candidatureService: CandidatureService,
              private serviceCandidat:CandidatService
) {}

  canActivate(): boolean {
 this.authService.isAuthenticated()
    .then(isAuthenticated => {

        if (isAuthenticated) {
            // User is authenticated
            let niveau =this.authService.loggedUser.role.niveau;
            // this.parametreService.initStructureParams();
            // this.parametreService.initStructureParams();
            //  this.parametreService.initAllParams(this.authService.getHeaders());


            if (niveau==2) {
                console.log("/structure ");

                // this.strutureService.getStructureDataByUser(this.authService.loggedUser.id);
                this.router.navigate(['/structure']);
                return false;
            } if (niveau>=3) {
                console.log("/admin/accueil");

                this.router.navigate(['/admin/accueil']);
                // return false;
            } else {
                // this.serviceCandidat.getCandidatForInfoByUser(this.authService.loggedUser.id);
                console.log("/candidat ");

                this.router.navigate(['/candidat']);
                // return false;
            }
            return true;
        } else {
            console.log('guard auth error');

            // User is not authenticated
            this.router.navigate(['/auth/login']);
            return false;
        }
    });

    return true;
  }
}
